import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'gatsby';

import { LocaleProvider } from '../core/Context/LocaleProvider';
import { SitemapProvider } from '../core/Context/SitemapProvider';
import { getTranslation, getPathFromSlug } from '../../utils/helpers';
import arrowRight from '../../images/arrowRight.svg';

import { NavBreadcrumbWrapper } from './styles.js';

const NavBreadcrumb = ({ className, parentPage ,siteConfiguration}) => {
  if (typeof window !== 'undefined') {
    const locale = useContext(LocaleProvider);
    //const sitemap = useContext(SitemapProvider);
    const sitemap = [];
    const backToTranslation = getTranslation(
      'back_to',
      siteConfiguration.translations,
      locale.code,
    );
    let parentLink;
    let parentName;
    let parentPagePath;
    if (parentPage[0].parentPage && parentPage[0].parentPage[0].slug) {
      parentPagePath = parentPage
        ? getPathFromSlug(sitemap.pages, parentPage[0].parentPage[0].slug, locale)
        : null;
      parentLink = (parentPagePath && parentPagePath.path) || null;
      parentName = (parentPage && parentPage[0].parentPage[0].pageName) || null;
    }
    if (!parentName) {
      return null;
    }
    return (
      <NavBreadcrumbWrapper className={`navBreadCrumb ${className || ''}`}>
        <Link to={`/${locale.code}/${parentLink || ''}`}>
          <span className="arrow">
            <img src={arrowRight} className="arrowLeft" />
          </span>
          {backToTranslation} {parentName && parentName}
        </Link>
      </NavBreadcrumbWrapper>
    );
  }
  return null;
};
export default NavBreadcrumb;
